import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    url = '';
    cookie = localStorage.getItem('CiDi') || 'cidi';
    constructor(
        private _router: Router,
        private _authService: AuthenticationService
    ) {
       this.url = this._router.url;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(catchError(err => {
            if (err.status === 401) {

                if (this.url === '/loginInterno') {
                    return throwError(err.error);
                }
                this._authService.logout(this.cookie);
                localStorage.clear();
                this._router.navigate(['/login']);
                location.reload();
            }

            return throwError(err.error);
        }));
    }
}
